<template>
    <div class="w-full flex flex-col justify-center my-2">
        <div class="flex flex-wrap justify-center">
            <div
                v-if="!!error"
                class="bg-theme-danger p-2 text-white border-sm"
                role="alert"
            >
                {{ error }}
            </div>
        </div>
        <div v-if="requiredAlt" class="flex flex-wrap px-4 py-4">
            <div class="w-full">
                <div class="form-group py-2">
                    <custom-input
                        v-model="alt"
                        type="text"
                        name="alt"
                        :disabled="isLoading"
                        label="Nombre del archivo"
                        aria-label="Alt"
                        autocomplete="off"
                        :error="
                            !validAlt && introValidators.alt
                                ? 'No ingrese simbolos raros, debe tener entre 5 y 64 carácteres.'
                                : ''
                        "
                        @blur="introValidators.alt = true"
                    >
                        <template #icon> 📃</template>
                    </custom-input>
                </div>
            </div>
        </div>
        <div v-if="wasUploaded && itemCurrent.id" class="flex justify-center">
            <div class="alert alert-success p-2">
                <a :href="url" target="_blank" rel="noopener">
                    {{ itemCurrent.name }}({{ itemCurrent.id }})
                </a>
            </div>
        </div>
        <div v-else class="flex-wrap flex justify-center" @click="clickButton">
            <label
                class="w-64 flex flex-col items-center px-4 py-6 btn bg-theme-success cursor-pointer rounded-lg text-uppercase"
            >
                <img
                    src="@/assets/images/upload.svg"
                    height="20"
                    width="20"
                    alt="upload file"
                />
                <span class="mt-2 text-white leading-normal">
                    {{ selectedFile ? file.name : "Selecciona archivo" }}
                </span>
                <input
                    id="application-uploader"
                    :disabled="isLoading || (!validAlt && requiredAlt)"
                    type="file"
                    accept="image/*,application/pdf"
                    class="hidden"
                    @input="uploadButton($event)"
                />
            </label>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { altRegex } from "@/common/lib/regex";

import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "FileUploader",
    components: { CustomInput },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: Object,
            required: false,
            default: () => ({ id: null, name: "" })
        },
        type: {
            default: () => "productFile",
            type: String,
            required: false
        },
        autoApprove: {
            default: () => false,
            type: Boolean,
            required: false
        },
        autoLoader: {
            default: () => false,
            type: Boolean,
            required: false
        },
        requiredAlt: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    data: () => ({
        id: null,
        url: "",
        alt: "",
        error: "",
        isLoading: false,
        wasUploaded: false,
        selectedFile: false,
        file: { name: "", type: "productFile", url: "" },
        introValidators: { alt: false }
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        validAlt() {
            return altRegex.test(this.alt);
        }
    },
    methods: {
        ...mapActions("files", [
            "getEndPointUploadFile",
            "uploadFile",
            "createFile"
        ]),
        async uploadButton(event) {
            const auxFile = event.target.files || event.dataTransfer.files;
            if (!auxFile.length) return;
            this.file = auxFile[0];
            const fileSize = this.file.size / 1048576;
            if (fileSize > 40) {
                this.error = "Archivo Demasiado Pesado Máximo 40 MB";
                return;
            }
            this.error = "";

            if (!this.autoApprove) {
                const dialogResult = await this.$swal.fire({
                    background: this.backgroundColor,
                    title: `Aseguras que ${this.file.name} es el archivo adecuado ?`,
                    icon: "info",
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText: "Si",
                    cancelButtonText: "No 😖",
                    confirmButtonColor: "#02913f",
                    cancelButtonColor: "#d33ddd",
                    allowOutsideClick: false
                });
                if (!dialogResult.isConfirmed) {
                    this.selectedFile = false;
                    return;
                }
            }

            this.isLoading = true;
            this.$emit("loading", true);
            if (this.autoLoader) {
                this.$loading.show();
            }
            try {
                const { alt, id, url, urlSigned } =
                    await this.getEndPointUploadFile({
                        fileName: this.file.name,
                        fileSize: this.file.size,
                        type: this.type,
                        alt: this.alt
                    });
                this.url = url;
                this.$emit("change", {
                    id,
                    url,
                    alt: this.alt,
                    type: this.type,
                    name: this.file.name
                });
                await this.uploadFile({
                    url: urlSigned,
                    file: this.file
                });
                this.$emit("created", {
                    name: this.file.name,
                    alt,
                    url,
                    id
                });
                this.wasUploaded = true;
                this.$emit("loading", false);
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$emit("loading", false);
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.error = error.message;
                this.$sound.play("error");
                this.wasUploaded = false;
                this.file = { name: "undefined", size: "11111" };
            }
        },
        async clickButton() {
            if (!this.validateData()) {
                this.error =
                    'Antes de subir la archivo verifica haber llenado el campo "Nombre de archivo"';
            }
        },
        validateData() {
            this.introValidators = { alt: false };
            return this.validAlt || !this.requiredAlt;
        }
    }
};
</script>
